import { useEffect, useRef } from 'react'
import { SDrawerOrModal } from 'shj-components'
import { Button, Spin, message } from 'antd'
import { useSetState } from 'ahooks'
import { initiateSchemeReview, submitSchemeReview } from '@/services/order'
interface IProps {
  title: string
  quoteId: string
  open: boolean
  setOpen: (open: boolean) => void,
  reload?: () => void
}
export default function ProgramProcessModal(prpos: IProps) {
  const formRef = useRef(null)
  const { open, title, setOpen, quoteId, reload = () => ({}) } = prpos
  const [state, setState] = useSetState<any>({
    loading: false,
    errInfo: [],
  })

  useEffect(() => {
    console.log('open---->', open)
    if (open) {
      setState({ loading: true })
      initiateSchemeReview({
        params: {
          quoteBudgetId: quoteId,
        }
      })
        .then(res => {
          console.log('res---->', res)
          setState({ errInfo: res })
        })
        .finally(() => {
          setState({ loading: false })
        })

    }
  }, [open])

  const onFormRef = () => {
    const { onFormRef } = formRef.current || {}
    return onFormRef?.()
  }

  const onsubmit = async () => {
    setState({ loading: true })
    try {
      const res = await submitSchemeReview({
        params: {
          quoteBudgetId: quoteId,
        }
      })
      setState({ loading: false })
      if (typeof res === 'string') {
        message.success('提交成功');
        setOpen(false)
        reload()
      }
    } catch (err) {
      setState({ loading: false });
      console.log(err)
    }
  }

  const onCancel = () => {
    onFormRef()?.resetFields()
    setOpen(false)
  }

  return (
    <SDrawerOrModal
      title={title}
      mode="modal"
      open={open}
      width={1000}
      onCancel={onCancel}
      antdProps={{
        footer: (
          <div>
            <Button onClick={onCancel}>取消</Button>
            <Button
              disabled={state.errInfo.length}
              style={{ marginLeft: 15 }}
              loading={state.loading}
              type="primary"
              onClick={onsubmit}
            >
              提交审核
            </Button>
          </div>
        ),
      }}
    >
      {open && (
        <div>
          <Spin spinning={state.loading}>
            <p>
              <span>1、当前报价方案以及整装图纸需要提交审核，请确保方案及图纸已完成再提交审核</span>
            </p>
            <p>
              <span>2、提交后将发起审核工单、可在我发起的工单中查看审核进度，审核通过后，设计师可以手动发起合同并推送给客户进行签约</span>
            </p>
            <div style={{ color: 'red' }}>
              {state.errInfo.length > 0 && <p style={{color: 'red'}}>异常信息：</p>}
              {state.errInfo.map((item: any, index: number) => {
                return (
                  <p style={{color: 'red'}}>
                    <span>
                      {index + 1}、{item}
                    </span>
                  </p>
                )
              })}
            </div>
          </Spin>
        </div>
      )}
    </SDrawerOrModal>
  )
}
